import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { IoMdLock, IoMdUnlock } from 'react-icons/io';
import { PiPasswordFill } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../context/UserProvider';
import DeletePopover from '../../common/DeletePopover';
import useBlockUnblockUser from './useBlockUser';
import TooltipItem from '../../../components/common/TooltipItem';
import useResetUserPassword from './useResetUserPassword';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const fields = [{ field: 'nombre' }, { field: 'correo electronico' }, { field: 'estado' }, { field: '' }];

function TableUsuarios({ users }) {
  const { userRole } = React.useContext(UserContext);
  const navigate = useNavigate();

  const { popover, handleClosePopover, handleClickPopover, handleConfirmPopover } = useBlockUnblockUser();
  const {
    resetPasswordPopover,
    handleCloseResetPasswordPopover,
    handleClickResetPasswordPopover,
    handleConfirmResetPasswordPopover,
  } = useResetUserPassword();

  return (
    <>
      {users?.length > 0 ? (
        <TableContainer component={Paper}>
          <Table sx={{ width: '100%' }} aria-label="customized table">
            <TableHead>
              <TableRow>
                {fields?.map((field, index) => (
                  <StyledTableCell align="left" key={index}>
                    {field?.field?.toUpperCase()}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {users?.map((user) => (
                <React.Fragment key={user.user_id}>
                  <StyledTableRow className={user?.blocked && 'row-inactive-users'}>
                    <StyledTableCell align="left">
                      <p className="cell-users">{user?.name}</p>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <p className="cell-users">{user?.email}</p>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <p className="cell-users">{user?.blocked ? 'Inactivo' : 'Activo'}</p>
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {userRole === 'MasterAdmin' && (
                        <div className="container-icons-edit-delete-master">
                          <EditIcon
                            className="tooltip-edit-user-icon"
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate(`${user?.user_id}/edit-users`)}
                          />
                          <PiPasswordFill
                            data-user-id={user.user_id}
                            className="tooltip-reset-password-icon"
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            onClick={(event) => handleClickResetPasswordPopover(event)}
                          />
                          {user?.blocked ? (
                            <IoMdUnlock
                              data-user-id={user.user_id}
                              onClick={(event) => handleClickPopover('unblock', event)}
                              className="tooltip-inactive-status-cluster-icon "
                              style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            />
                          ) : (
                            <IoMdLock
                              data-user-id={user.user_id}
                              onClick={(event) => handleClickPopover('block', event)}
                              className="tooltip-active-status-cluster-icon"
                              style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            />
                          )}
                        </div>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>

                  <DeletePopover
                    textCancel={'No'}
                    textConfirm={'Sí'}
                    textQuestion={'¿Estás seguro de que deseas activar este usuario?'}
                    handleDeleteClose={() => handleClosePopover('unblock')}
                    deletePopover={popover('unblock')}
                    handleDeleteConfirm={() => handleConfirmPopover('unblock')}
                  />
                  <DeletePopover
                    textCancel={'No'}
                    textConfirm={'Sí'}
                    textQuestion={
                      '¿Estás seguro de que deseas desactivar este usuario?, el usuario no podrá acceder a la aplicación.'
                    }
                    handleDeleteClose={() => handleClosePopover('block')}
                    deletePopover={popover('block')}
                    handleDeleteConfirm={() => handleConfirmPopover('block')}
                  />

                  <DeletePopover
                    textCancel={'No'}
                    textConfirm={'Sí'}
                    textQuestion={
                      '¿Estás seguro de que quieres resetear la contraseña del usuario?. Se generará una nueva contraseña, la anterior quedará invalidada. Se le enviará al usuario un correo con el contenido de la contraseña generada.'
                    }
                    handleDeleteClose={() => handleCloseResetPasswordPopover()}
                    deletePopover={resetPasswordPopover}
                    handleDeleteConfirm={() => handleConfirmResetPasswordPopover()}
                  />
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <h3 style={{ fontWeight: 'bolder' }}>No hay usuarios para los filtros seleccionados</h3>
      )}

      {/* TOOLTIP PARA LOS ICONOS */}
      <TooltipItem content="Editar usuario" className="tooltip-edit-user-icon" position="top" />
      <TooltipItem content="Resetear contraseña" className="tooltip-reset-password-icon" position="top" />
      <TooltipItem content="Inactivar usuario" className="tooltip-active-status-cluster-icon" position="top" />
      <TooltipItem content="Activar usuario" className="tooltip-inactive-status-cluster-icon" position="top" />
    </>
  );
}

export default TableUsuarios;
